<!-- 车辆管理-车辆台账 -->

<template>
  <div class="vehicle-ledger main-cnt">
    <div class="title flex-btw align-center">
      <div>车辆台账</div>
      <el-button type="primary" round @click="onAddBtn"
        v-if="authData.indexOf('n_403a6aaec6558aa69ecbac902') != -1">新增车辆</el-button>
    </div>

    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :apiName="VipApi.getVehicleLists"
        :columns="tableColumns" @onDetails="onDetails">
        <template #status="{ row }">
          <!-- 有权限 -->
          <template v-if="authData.indexOf('n_a1bc770b0a2a68071e1156058') != -1">
            <el-popconfirm :title="`确定要修改车辆状态吗?`" @confirm="lineStatusChange(row)">
              <template #reference>
                <el-switch v-model="row.status" :active-value="1" :inactive-value="2" :width="60" active-text="正常"
                  inactive-text="报废" :before-change="() => false" class="vehicle-switch" />
              </template>
            </el-popconfirm>
          </template>

          <!-- 没有权限 -->
          <template v-else>
            <el-switch v-model="row.status" :active-value="1" :inactive-value="2" :width="60" active-text="正常"
              inactive-text="报废" :before-change="() => false" :disabled="true" />
          </template>
        </template>
      </common-table>
    </div>

    <w-dialog ref="dialogRef" class="vehicle-dialog" :title="dialogTitle" width="28%" btnWidth="140px" top="15vh"
      :confirmText="ruleForm.id ? '提交保存' : '确认新增'" @wConfirm="handleSure" :hideFooter="!isEdit">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="formRules" labelPosition="top">
        <el-form-item label="车牌号" prop="plate">
          <el-input v-model="ruleForm.plate" placeholder="请输入车牌号" clearable :disabled="!isEdit"></el-input>
        </el-form-item>
        <el-form-item label="座位数" prop="count">
          <el-input v-model="ruleForm.count" type="number" placeholder="请输入座位数" clearable :disabled="!isEdit"
            oninput="if(value<0)value=0"></el-input>
        </el-form-item>
        <el-form-item label="责任司机" prop="driver">
          <el-popover ref="popoverRef" placement="bottom" :width="500" trigger="click" @show="showSearch"
            :disabled="!isEdit">
            <template #reference>
              <div class="selected-driver">
                <div v-if="selectedDriver.length == 0" style="color:#c0c4cc;">请输入</div>
                <div v-else class="flex flex-wrap">
                  <div v-for="(item, i) in selectedDriver" :key="i" class="flex-btw align-center driver-content">
                    <div class="driver-name">{{ item.u_name }}</div>
                    <div class="cursor-pointer" @click.capture.stop="deleteDriver(i)" v-if="isEdit">
                      <el-icon style="font-size: 16px;padding-top: 15px;">
                        <Close />
                      </el-icon>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div>
              <el-input v-model="keyword" :prefix-icon="Search" placeholder="请输入姓名或手机号" clearable
                @input="searchDriver"></el-input>
              <div style="height: 300px;overflow: auto;margin-top: 10px;">
                <div v-if="driverList.length == 0" class="flex-center">暂无数据！</div>
                <div v-else v-for="(item, i) in driverList" :key="i" @click="onClickList(item)"
                  class="driver-list cursor-pointer">
                  <el-row>
                    <el-col :span="8">{{ item.u_name }}</el-col>
                    <el-col :span="10">{{ item.u_tel }}</el-col>
                    <el-col :span="6">{{ item.du_name }}</el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-popover>
          <div class="pour">责任司机非必填，添加司机后派单环节可以快捷选中司机</div>
        </el-form-item>
      </el-form>
    </w-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage } from "element-plus";
import { Close, Search, } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { isVehicleNumber } from "@/utils/common.js";

const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

/** 表格对象 */
const tableRef = ref(null);
/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "id",
    label: "ID",
  },
  {
    prop: "plate",
    label: "车辆牌号",
  },
  {
    prop: "count",
    label: "座位数",
  },
  {
    prop: "driver_name",
    label: "责任司机",
  },
  {
    prop: "status",
    type: "customRender",
    label: "车辆状态",
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 100,
    bottons: [
      {
        name: "详情",
        action: "onDetails",
        token: "n_b0996a208ecdc48b1a35066d5",
      },
    ],
  },
]);
const dialogRef = ref(null);  // 对话框
const dialogTitle = ref('');  // 对话框标题
const formRef = ref(null);  //表单
const ruleForm = ref({
  plate: '',  // 车牌号
  count: '',  // 座位数
  driver: [], // 责任司机
});
const formRules = {
  plate: [{ required: true, message: "请输入车牌号", trigger: "blur" },],
  count: [{ required: true, message: "请输入座位数", trigger: "blur" },],
};
const popoverRef = ref(null);
const selectedDriver = ref([]); // 选中的司机
const driverList = ref([]); // 司机列表
const keyword = ref(''); // 搜索司机关键字
const isEdit = ref(false); // 是否有编辑权限
/**
 * 
 * 新增按钮
 * 
 **/
const onAddBtn = () => {
  dialogTitle.value = '新增车辆';
  ruleForm.value.plate = '';
  ruleForm.value.count = '';
  selectedDriver.value = [];
  isEdit.value = true;
  dialogRef.value.show();
}
/**
 * 
 * 确定按钮
 * 
 **/
const handleSure = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      if (isVehicleNumber(ruleForm.value.plate)) {
        dialogRef.value.isLoading = true;
        let params = {
          plate: ruleForm.value.plate,
          count: ruleForm.value.count,
          driver: selectedDriver.value.map(item => item.u_id).join(','),
        };
        let url = ruleForm.value.id ? 'editCarDiver' : 'addCarDiver';
        if (ruleForm.value.id) {
          params.id = ruleForm.value.id;
        }
        // console.log('params', params, url);
        VipApi[url](params).then((res) => {
          dialogRef.value.isLoading = false;
          if (res.Code === 200) {
            tableRef.value.tableLoad();
            ElMessage.success("操作成功！");
            dialogRef.value.close();
          } else {
            ElMessage.error(res.Message);
          }
        });
      } else {
        ElMessage.error("请填写正确的车牌号！");
      }
    }
  });
}
/**
 * 
 * 显示搜索司机页面
 * 
 **/
const showSearch = () => {
  keyword.value = '';
  driverList.value = [];
}
/**
 * 
 * 搜索司机
 * 
 **/
const searchDriver = () => {
  if (keyword.value) {
    VipApi.searchCarDiver({ keyword: keyword.value }).then((res) => {
      if (res.Code === 200) {
        driverList.value = res.Data ? res.Data : [];
      } else {
        ElMessage.error(res.Message);
      }
    });
  } else {
    driverList.value = [];
  }
}
/**
 * 
 * 点击司机
 * 
 **/
const onClickList = (item) => {
  // 判断是否已选中
  const isSelected = selectedDriver.value.some(driver => driver.u_id === item.u_id);
  if (!isSelected) {
    selectedDriver.value.push(item);
    driverList.value = [];
    keyword.value = '';
    popoverRef.value.visibility = false;  // 直接设置visibility属性为false来关闭Popover。
  } else {
    ElMessage.error('该司机已选中！');
  }
}
/**
 * 
 * 删除已选司机
 * 
 **/
const deleteDriver = (index) => {
  selectedDriver.value.splice(index, 1);
}
/**
 * 
 * 详情按钮
 * 
 **/
const onDetails = (row) => {
  isEdit.value = authData.value.indexOf('n_7c99a34040a5403babf26a7ad') != -1;
  dialogTitle.value = '详情';
  ruleForm.value.id = row.id;
  getDetailsData();
}
/**
 * 
 * 获取详情数据
 * 
 **/
const getDetailsData = () => {
  VipApi.getCarDetails({ id: ruleForm.value.id }).then((res) => {
    if (res.Code === 200) {
      ruleForm.value.plate = res.Data.plate;
      ruleForm.value.count = res.Data.count;
      selectedDriver.value = res.Data.driver_list;
      dialogRef.value.show();
    } else {
      ElMessage.error(res.Message);
    }
  });
}
/**
 * 
 * 修改在线状态
 * 
 * **/
const lineStatusChange = (row) => {
  VipApi.updateVehicleState({ id: row.id, }).then((res) => {
    if (res.Code === 200) {
      ElMessage.success("修改成功！");
      tableRef.value.tableLoad();
    } else {
      ElMessage.error(res.Message);
    }
  });
}

onMounted(() => {
  tableRef.value.tableLoad();
});

</script>

<style lang="scss">
.vehicle-ledger {
  font-family: "Source Han Sans CN";

  .content {
    padding: 15px 20px 20px;

    .vehicle-switch .el-switch__label {
      position: absolute;
      display: none;
      color: #fff;
    }

    .vehicle-switch .el-switch__label--left {
      z-index: 1;
      left: 6px;
    }

    .vehicle-switch .el-switch__label--right {
      z-index: 1;
      left: -14px;
    }

    .vehicle-switch .el-switch__label.is-active {
      display: block;
      text-align: center;
    }
  }

  .vehicle-dialog {
    .selected-driver {
      background-color: var(--search-uncheck-bg-color);
      border-radius: 4px;
      padding: 0 15px;
      line-height: 40px;
    }

    .driver-content {
      border: 1px solid var(--theme-color);
      background-color: var(--search-bg-color);
      color: var(--theme-color);
      height: 26px;
      width: 74px;
      border-radius: 4px;
      margin: 7px 10px 7px 0;
      padding: 0 4px;
    }

    .pour {
      color: #F0170A;
    }
  }
}
</style>
